// ======================
// TGF. Universal Animation System — Horizon Theme
// ======================
// Brand tone: calm, real, quietly confident
// ======================

document.addEventListener("DOMContentLoaded", () => {
  // 1️⃣ Fade + Parallax Reveal Animation
  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("fade-in-up");
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );

  // Automatically tag key elements site-wide
  const selectors = [
    "section",
    ".product-card",
    ".card",
    ".shopify-section",
    ".collection",
    ".banner",
    ".grid__item",
    ".image-with-text",
    "button",
    ".button"
  ];

  document.querySelectorAll(selectors.join(",")).forEach(el => {
    el.classList.add("reveal");
    observer.observe(el);
  });

  // Gentle parallax motion for visible items
  window.addEventListener("scroll", () => {
    const scrolled = window.scrollY * 0.05; // low impact = calm
    document.querySelectorAll(".reveal.fade-in-up").forEach(el => {
      el.style.transform = `translateY(${Math.sin(scrolled * 0.1)}px)`;
    });
  });

  // 2️⃣ Initialize AOS for smooth fade cascade
  if (window.AOS) {
    const fadeElements = document.querySelectorAll(
      "section, .product-card, .card, .image-with-text, .collection-list, .article-card, .grid__item"
    );
    fadeElements.forEach((el, index) => {
      el.setAttribute("data-aos", "fade-up");
      el.setAttribute("data-aos-delay", index * 100);
    });

    AOS.init({
      duration: 1000,
      easing: "ease-out-quart",
      once: true,
      offset: 120
    });
  }

  // 3️⃣ Page transition overlay (for smoother navigation)
  const overlay = document.querySelector(".page-transition");
  window.addEventListener("beforeunload", () => overlay && overlay.classList.remove("hidden"));
  window.addEventListener("load", () => overlay && overlay.classList.add("hidden"));
});
